module.exports = __webpack_public_path__ + "eb122d7f30a728261fcafcc8606a794d.pdf";